<template>
  <div>
    <v-container class="ml-10 mr-10">
      <p class="display-1 mt-7">애프터케어 신청 관리</p>
      <p class="mb-0 subtitle-1 font-weight-light">
        쇼핑몰에서 고객이 애프터케어를 신청한 내역을 확인/관리 할 수 있습니다.
      </p>
      <p class="mb-0 subtitle-1 font-weight-light">
        애프터케어 처리 상태를 변경하고 수리금액, 운송장번호, 메모를 입력하여 관리할 수 있습니다.
      </p>

      <ManageAftercareSearch ref="searchComponent"></ManageAftercareSearch>
      <ManageAftercareList ref="listComponent"></ManageAftercareList>
    </v-container>
  </div>
</template>

<script>
import ManageAftercareSearch from "@/components/authservice/aftercare/ManageAftercareSearch.vue";
import ManageAftercareList from "@/components/authservice/aftercare/ManageAftercareList.vue";

export default {
  components: {
    ManageAftercareSearch,
    ManageAftercareList,
  },
};
</script>
